import React, { Component, Fragment } from 'react';
import { Typography } from 'rmwc';
import { wlVar } from '../helpers/whitelabel';
import { humanPhoneNumber } from '../helpers/stringHelper';

import {
  Dialog,
  DialogSurface,
  DialogHeader,
  DialogHeaderTitle,
  DialogBackdrop,
  DialogBody,
  DialogFooter,
  DialogFooterButton,
} from 'rmwc/Dialog';

const popUpDisclaimer = {
  field: 'disclosure',
  label: 'Disclosure',
  text: wlVar('disclosure')
};
const popUpPrivacyPolicy = {
  field: 'privacyPolicy',
  label: 'Privacy Policy',
  text: wlVar('privacy_policy'),
};

const popUps = [popUpPrivacyPolicy, popUpDisclaimer];

export class LegalNotices extends Component {
  constructor(props) {
    super(props);
    this.state = {
      privacyPolicy: false,
      disclosure: false,
    };
  }

  renderPopUp = popUp => (
    <Dialog key={popUp.field} open={this.state[popUp.field]} onClose={evt => this.setState({ [popUp.field]: false })}>
      <DialogSurface>
        {popUp.text && (
          <div>
            <DialogHeader>
              <DialogHeaderTitle>{popUp.label}</DialogHeaderTitle>
            </DialogHeader>
            <DialogBody dangerouslySetInnerHTML={{ __html: popUp.text }} />
          </div>
        )}
        {popUp.field === 'disclosure' && wlVar('disclaimer') && (
          <div>
            <DialogHeader>
              <DialogHeaderTitle>Disclaimer</DialogHeaderTitle>
            </DialogHeader>
            <DialogBody dangerouslySetInnerHTML={{ __html: wlVar('disclaimer') }} />
          </div>
        )}        
        <DialogFooter>
          <DialogFooterButton cancel accept>
            OK
          </DialogFooterButton>
        </DialogFooter>
      </DialogSurface>
      <DialogBackdrop />
    </Dialog>
  );

  render() {
    return (
      <Typography tag="div" use="body1" className="mt-2" style={{ color: '#606060' }}>
        <span
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={evt => this.setState({ [popUpPrivacyPolicy.field]: true })}
        >
          {popUpPrivacyPolicy.label}
        </span>
        {' | '}
        <span
          style={{ cursor: 'pointer', textDecoration: 'underline' }}
          onClick={evt => this.setState({ [popUpDisclaimer.field]: true })}
        >
          {popUpDisclaimer.label}
        </span>
        <div>{popUps.map(this.renderPopUp)}</div>
      </Typography>
    );
  }
}
